<template>
  <section class="layout-pt-lg layout-pb-lg tw-h-[100svh]">
    <!-- Mobile Video - Highest Priority -->
    <video
      v-if="isMobileDevice && vars.mobileBackgroundVideo && typeof vars.mobileBackgroundVideo === 'string'"
      :src="vars.mobileBackgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      loop
      muted
      playsinline
    ></video>

    <!-- Desktop Video - Second Priority -->
    <video
      v-else-if="vars.backgroundVideo && typeof vars.backgroundVideo === 'string'"
      :src="vars.backgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      loop
      muted
      playsinline
    ></video>

    <!-- Mobile Image - Only if no mobile video -->
    <NuxtImg
      :lazy="true"
      placeholder="blur"
      v-else-if="vars.mobileBackgroundImage && isMobileDevice && typeof vars.mobileBackgroundImage === 'string'"
      :src="vars.mobileBackgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />

    <!-- Desktop Image - Only if no video at all -->
    <NuxtImg
      :lazy="true"
      placeholder="blur"
      v-else-if="vars.backgroundImage && typeof vars.backgroundImage === 'string'"
      :src="vars.backgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />

    <div class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-25"></div>

    <div class="tw-relative tw-z-10 tw-flex tw-h-screen tw-w-full tw-items-end tw-justify-center landscape:tw-pb-2 max-sm:tw-pb-1">
      <div
        class="tw-z-100 tw-my-0 tw-mb-0 tw-flex tw-max-w-[1000px] tw-flex-col tw-items-center tw-gap-2 tw-px-3 tw-py-1 tw-text-start landscape:tw-mb-0 landscape:tw-gap-1 landscape:tw-py-0 md:tw-my-4 md:tw-mb-8 md:tw-px-14 md:tw-py-10 xl:tw-w-[90%] xl:tw-gap-6 xl:tw-px-10"
      >
        <h1 class="tw-mb-6 tw-text-center tw-text-white landscape:tw-mb-2 md:tw-mb-10">
          {{ vars.titleText }}
        </h1>

        <div
          class="tw-hidden tw-flex-wrap tw-items-center tw-justify-start tw-gap-10 min-[480px]:tw-flex min-[480px]:tw-flex-nowrap"
        >
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`herosection-desktop-button-${index}`"
            :class="`n-${button.type} n-btn`"
            :to="typeof button.link === 'string' ? button.link : '#'"
            :external="true"
          >
            <div class="n-btn-container">
              <div class="n-btn-group">
                <div class="n-btn-t1">{{ button.label }}</div>
              </div>
            </div>
          </nuxt-link>
        </div>

        <div class="tw-flex tw-w-full tw-flex-col tw-gap-2 min-[480px]:tw-hidden landscape:tw-flex-row landscape:tw-flex-wrap landscape:tw-justify-center landscape:tw-gap-2">
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`herosection-mobile-button-${index}`"
            :class="`n-${button.type} n-btn tw-w-full landscape:tw-w-auto landscape:tw-flex-1 landscape:tw-min-w-[200px]`"
            :to="typeof button.link === 'string' ? button.link : '#'"
            :external="true"
          >
            <div class="n-btn-container tw-flex tw-justify-center">
              <div class="n-btn-group">
                <div class="n-btn-t1 tw-text-center">{{ button.label }}</div>
              </div>
            </div>
          </nuxt-link>
        </div>

        <div class="banner-scroll-down tw-hidden landscape:tw-hidden lg:tw-block lg:landscape:tw-hidden"></div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  name: 'HeroSection',

  mixins: [ComponentMixin],

  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },
  },

  methods: {
    scrollToNextSection() {
      const start = window.scrollY;
      const target = start + window.innerHeight * 0.98;
      const duration = 700;
      const startTime = performance.now();

      const animateScroll = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const ease = progress * (2 - progress);

        window.scrollTo(0, start + (target - start) * ease);

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    },
  },
});
</script>

<style scoped>
.banner-scroll-down {
  position: absolute;
  left: 90%;
  transform: translateX(-50%);
  bottom: 80px;
}
.banner-scroll-down a span {
  border-color: var(--white);
}

.banner-scroll-down a {
  color: var(--white);
  display: block;
  width: 30px;
  height: 50px;
  text-align: center;
}
.banner-scroll-down a span {
  display: block;
  width: 17px;
  height: 17px;
  border-bottom: 3px solid var(--white);
  border-right: 3px solid var(--white);
  transform: rotate(45deg);
  margin: -10px 0 0 8px;
  animation: animate 2s infinite;
}
.banner-scroll-down a span:nth-child(2) {
  animation-delay: -0.2s;
}
.banner-scroll-down a span:nth-child(3) {
  animation-delay: -0.4s;
}
@keyframes animate {
  0% {
    opacity: 0;
    transform: rotate(45deg) translate(-15px, -15px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(45deg) translate(15px, 15px);
  }
}
</style>
